/**
 * CustomerBrowserData interface is build base on the BOIPA documentation.
 * Appendix C customerBrowser Data Elements Definitions
 * @see @{link https://github.com/BOIPA/BOIPA_Gateway_PHP_SDK/blob/master/docs/2.1%20-%20BOIPA%20Gateway%20-%20AUTH-PURCHASE-VERIFY%20-%20Direct%20API.pdf}
 */

/**
 * Values accepted:
 * 1 = 1 bit
 * 4 = 4 bits
 * 8 = 8 bits
 * 15 = 15 bits
 * 16 = 16 bits
 * 24 = 24 bits
 * 32 = 32 bits
 * 48 = 48 bits
 * @example
 *  browserColorDepth = '24'
 */
export type ColorDepth = '1' | '4' | '8' | '15' | '16' | '24' | '32' | '48';
/**
 * Values accepted:
 * 01 - 250 x 400
 * 02 - 390 x 400
 * 03 - 500 x 600
 * 04 - 600 x 400
 * 05 - Full screen
 * @example
 *  challengeWindowSize = '05'
 */
export type WindowSize = '01' | '02' | '03' | '04' | '05';
/**
 * Type of device used, accepted values:
 * MOBILE
 * DESKTOP
 */
export type UserDevice = 'DESKTOP' | 'MOBILE';

/**
 * CustomerBrowserData interface is build base on the BOIPA documentation.
 * Appendix C customerBrowser Data Elements Definitions
 * @see @{link https://github.com/BOIPA/BOIPA_Gateway_PHP_SDK/blob/master/docs/2.1%20-%20BOIPA%20Gateway%20-%20AUTH-PURCHASE-VERIFY%20-%20Direct%20API.pdf}
 */
export interface CustomerBrowserData {
  customerBrowser: {
    browserAcceptHeader: string;
    browserJavaEnabled: boolean;
    browserJavascriptEnabled: boolean;
    browserLanguage: string;
    browserColorDepth: ColorDepth;
    browserScreenHeight: number;
    browserScreenWidth: number;
    browserTZ: number;
    challengeWindowSize: WindowSize;
  };
  userAgent: string;
  userDevice: UserDevice;
  /**
   * Customer IP Address will be added by API.
   */
  customerIPAddress?: string;
}
